import { render } from "./MenuBlock.vue?vue&type=template&id=004512ce&scoped=true&ts=true"
import script from "./MenuBlock.vue?vue&type=script&lang=ts"
export * from "./MenuBlock.vue?vue&type=script&lang=ts"

import "./MenuBlock.vue?vue&type=style&index=0&id=004512ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004512ce"]])

export default __exports__